import React from "react";
import { Select } from "antd";

const { Option } = Select;

export default function CustomLabelDropdown({
  labelText,
  isCompulsary,
  controlId,
  controlName,
  value,
  options = [],
  handleSelectChange,
  errorMessage,
  isDisabled,
  placeholder,
  wrapperClass = "",
  mode,
  showSearch = false,
  optionFilterProp,
  filterOption,
  maxTagCount,
  notFoundContent,
  dropdownRender,
  onChange,
  allowClear = false,
  ...rest 
}) {
  return (
    <div className={`flex flex-col ${wrapperClass}`}>
      {/* Label */}
      {labelText && (
        <label className="text-[1rem] font-medium text-[#5d5d5d] mb-2">
          {labelText}
          {isCompulsary && <span className="text-red-500 ml-[1px]">*</span>}
        </label>
      )}

      {/* Ant Design Select */}
      <Select
        id={controlId}
        name={controlName}
        value={value || undefined}
        onChange={(val) => {
          if (handleSelectChange) handleSelectChange(val);
          if (onChange) onChange(val);
        }}
        disabled={isDisabled}
        placeholder={placeholder}
        className={`
          !w-full
          ${
    mode === "multiple" || mode === "tags"
      ? "[&_.ant-select-selector]:!min-h-[46px]"
      : "[&_.ant-select-selector]:!h-[46px]"
  }
          [&_.ant-select-selector]:!rounded-[0.625rem]
          [&_.ant-select-selector]:!border-[#d9d9d9]
          [&_.ant-select-selector]:!px-[1rem]
          [&_.ant-select-selector]:!flex
          [&_.ant-select-selector]:!items-center
          [&_.ant-select-selector]:!shadow-none
          [&_.ant-select-selection-wrap]:!mt-[5px]
          [&_.ant-select-arrow]:!mt-[3px] 
          hover:[&_.ant-select-selector]:!border-[#e74860]
          ${errorMessage
            ? "[&_.ant-select-selector]:!border-[#ff4d4f] [&_.ant-select-selector]:shadow-[0_0_2px_rgba(255,77,79,0.2)]"
            : ""
          }
          ${isDisabled
            ? "[&_.ant-select-selector]:!bg-[#fafafa] [&_.ant-select-selector]:!text-[#999]"
            : ""
          }
        `}
        allowClear={allowClear} 
        optionFilterProp={optionFilterProp || "children" || "label"}
        popupClassName="!rounded-[0.625rem] !shadow-[0px_4px_12px_rgba(0,0,0,0.1)]"
        getPopupContainer={(trigger) => trigger.parentNode}
        showSearch={showSearch}
        filterOption={filterOption || ((input, option) =>
    String(option?.label || "")
      .toLowerCase()
      .includes(input.toLowerCase()))}
        mode={mode}
        maxTagCount={maxTagCount}
        notFoundContent={notFoundContent}
        dropdownRender={dropdownRender}
        placement="bottomLeft"
        dropdownAlign={{ points: ["tl", "bl"] }}
        {...rest} 
        options={options}
      >
      </Select>

      {/* Error Message */}
      {errorMessage && (
        <span className="text-[#ff4d4f] text-[0.75rem] mt-1">
          {errorMessage}
        </span>
      )}
    </div>
  );
}